import { DomainModelHelper } from '@digital-platform/shared/domain';
import { UserInfo, UserInfoModel } from '@digital-platform/users/domain';
import { CommentLogHistory } from '../interfaces';

export class CommentLogHistoryModel implements CommentLogHistory {
  readonly date: Date;
  readonly user: UserInfo;
  readonly comment: string;

  public static DEFAULT_CONFIG: CommentLogHistory = {
    date: null,
    user: null,
    comment: '',
  };

  constructor(config?: CommentLogHistory) {
    this.date = config
      ? DomainModelHelper.ensureDataIsDate(config.date)
      : CommentLogHistoryModel.DEFAULT_CONFIG.date;
    this.user = config
      ? new UserInfoModel(config.user)
      : CommentLogHistoryModel.DEFAULT_CONFIG.user;
    this.comment = config
      ? DomainModelHelper.ensureDataIsString(config.comment)
      : CommentLogHistoryModel.DEFAULT_CONFIG.comment;
  }
}
